// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__subtitle[data-v-9806ef40]{letter-spacing:.025rem}.diagnostics-list[data-v-9806ef40]{margin:0;padding-left:1rem}", ""]);
// Exports
module.exports = exports;
